<script>
import { Line } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

export default {
  extends: Line,
  props: {
    datasets: {
      type: Array,
      required: true
    },
    labels: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.renderChartWithProps();
  },
  watch: {
    datasets: {
      handler() {
        this.renderChartWithProps();
      },
      deep: true
    },
    labels: {
      handler() {
        this.renderChartWithProps();
      },
      deep: true
    }
  },
  methods: {
    renderChartWithProps() {
      const maxDataValue = Math.max(...this.datasets.flatMap(dataset => dataset.data));
      const yAxisMax = Math.round(maxDataValue * 1.2);

      this.renderChart(
        {
          labels: this.labels,
          datasets: this.datasets
        },
        {
          tooltips: {
            enabled: true,
            callbacks: {
              label: function(tooltipItem, data) {
                const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                const label = data.labels[tooltipItem.index];
                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                return `${datasetLabel}: ${label} - ${value}`;
              }
            }
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              display: true,
              ticks: {
                callback: function(value) {
                  return value;
                }
              },
              fontColor: '#ffffff'
            }],
            yAxes: [{
              display: true,
              ticks: {
                callback: function(value) {
                  return value;
                },
                stepSize: 50,
                min: 0,
                max: yAxisMax
              },
              fontColor: '#ffffff'
            }]
          },
          elements: {
            line: {
              tension: 0.4,
              borderWidth: 2
            },
            point: {
              radius: 0,
              hitRadius: 10,
              hoverRadius: 4
            }
          },
          layout: {
            padding: {
              left: 10,
              right: 10,
              top: 10,
              bottom: 10
            }
          },
          plugins: {
            backgroundColor: '#ffffff',
            borderColor: '#ffffff',
            borderWidth: 1
          }
        }
      );
    }
  }
}
</script>